function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component, createRef } from "react";
import { Snackbar } from "@xo-union/tk-component-alerts";
import { compose } from "@xo-union/react-css-modules";
import styles from "./styles.css";
var Toast = /*#__PURE__*/function (_Component) {
  _inherits(Toast, _Component);
  var _super = _createSuper(Toast);
  function Toast(props) {
    var _this;
    _classCallCheck(this, Toast);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "toastContainer", function () {
      return /*#__PURE__*/createRef();
    }());
    _defineProperty(_assertThisInitialized(_this), "snackbar", function () {
      return /*#__PURE__*/createRef();
    }());
    _this.state = {
      hiddenDom: !props.toast
    };
    return _this;
  }
  _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var engagementRingProgressBar = document.getElementsByClassName('instructions');
      if (engagementRingProgressBar.length) {
        this.toastContainer.current.classList.add(styles.engagementRingToastContainer);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (this.props.toast && this.props.toast !== prevProps.toast) {
        this.setState({
          hiddenDom: false
        }, function () {
          _this2.snackbar.current.showAndDismiss({
            data: _this2.props.toast,
            dismissTimeout: 4000
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var hiddenDom = this.state.hiddenDom;
      var closeBtnClasses = compose(styles);
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles['toast-container'], " ").concat(styles[this.props.classes]),
        ref: this.toastContainer
      }, /*#__PURE__*/React.createElement("a", {
        "aria-label": "go to my wedding vision",
        "aria-hidden": hiddenDom,
        className: hiddenDom ? styles['hidden'] : '',
        href: "/your-favorites/inspiration",
        tabIndex: hiddenDom ? -1 : undefined,
        target: "_blank",
        role: "link"
      }, /*#__PURE__*/React.createElement(Snackbar, {
        ref: this.snackbar,
        classes: closeBtnClasses,
        fixedToRelative: true
      })));
    }
  }]);
  return Toast;
}(Component);
export { Toast as default };